import { useEffect, useState } from 'react';
import { entries, markWhatsNewRead, useUnreadWhatsNew } from '../lib/whats-new.js';

/** The bell with the red dot, and the panel that slides out from the right when it is pressed. */
export function WhatsNew({ userId }: { userId: string }) {
  const unread = useUnreadWhatsNew(userId);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) markWhatsNewRead(userId);
  }, [open, userId]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <>
      <button
        type="button"
        className="whats-new-btn"
        onClick={() => setOpen(true)}
        aria-label={unread ? "What's new (unread)" : "What's new"}
        title="What's new"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.7 21a2 2 0 0 1-3.4 0" />
        </svg>
        {unread ? <span className="whats-new-dot" aria-hidden="true" /> : null}
      </button>
      {open ? (
        <>
          <div className="whats-new-backdrop" onClick={() => setOpen(false)} aria-hidden="true" />
          <aside className="whats-new-panel" role="dialog" aria-label="What's new">
            <div className="section-head">
              <h2>What's new</h2>
              <button type="button" className="link-btn" onClick={() => setOpen(false)}>
                Close
              </button>
            </div>
            {entries.map((entry, i) => (
              <section key={entry.id} className="whats-new-entry">
                <h3>
                  {entry.title} {i === 0 ? <span className="badge badge-ok">latest</span> : null}
                </h3>
                <div className="muted tiny">{entry.date}</div>
                <ul>
                  {entry.changes.map((c) => (
                    <li key={c}>{c}</li>
                  ))}
                </ul>
              </section>
            ))}
          </aside>
        </>
      ) : null}
    </>
  );
}
